import { APPLICATION_ROUTES } from '@philips-emr/hpms-stipulator-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export default function registerRelatorios(): void {

  applicationModuleRegistry.register({
    entry: 'relatorios',
    id: 'relatorios',
    name: 'stipulator.relatorios',
    route: APPLICATION_ROUTES.RELATORIOS,
    order: 7,
    closeable: true,
  });
}
